import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';

import SmartChip from './SmartChip';
import useSmartChipQuery, {ChipItem, SmartChipType} from './useSmartChipQuery';

function getProcedureRunUrl(procedureRun: ChipItem<SmartChipType.PROCEDURE_RUN>): string {
  const {study} = procedureRun;
  if (study.__typename === 'StudyNode') {
    return `${study.editUrl}?runId=${procedureRun.id}`;
  }
  return '';
}

export default function ProcedureRunChip(
  props: SharedSmartChipProps<SmartChipType.PROCEDURE_RUN>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: procedureRun,
    handleClickLink,
    isInaccessible,
    itemUrl,
  } = useSmartChipQuery<SmartChipType.PROCEDURE_RUN>({
    id,
    onClick,
    getUrlFn: getProcedureRunUrl,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={null}
      isInaccessible={isInaccessible}
      isReadonly={!itemUrl}
      item={procedureRun}
      onClick={handleClickLink}
      url={itemUrl || null}
    />
  );
}
